export const headerMapper = {
    navLinks: [
        { id: 'home', label: 'Home', href: '#home' },
        { id: 'empresa', label: 'Empresa', href: '#empresa' },
        { id: 'solucoes', label: 'Soluções', href: '#solucoes' },
        { id: 'contato', label: 'Contato', href: '#contato' },
    ],
};
